<div class="h-full overflow-auto">
  @if (loadingAllSpinner$()) {
    <div
      name="app-initial-loading"
      class="fixed inset-0 flex justify-center items-center bg-black/40 backdrop-blur-sm z-50">
      <div class="flex items-center">
        <div
          class="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <div class="ml-4 text-white text-lg">Loading...</div>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
</div>
